const Mediator = require('mediator-js');
const mediator = new Mediator();

// const caruselLogic = require('./carusel-logic.js');
// let progress = caruselLogic.progress;
// console.log(progress);

// {
//     mediator.subscribe('progress:click', data => {
//         // console.log(data);
//         data;
//     });
// }

{
    let lastStep;
    mediator.subscribe('steps:setactive', step => {
        if (lastStep !== step) {
            lastStep = step;
            mediator.publish('steps:newstep', step);
        }
    });
}

{
    mediator.subscribe('steps:newstep', step => {
        mediator.publish('modals:show', step.id);
    });
}

{
    mediator.subscribe('modals:lastscroll', (modalID, hiddenModal) => {
        if (!hiddenModal && modalID === 5 && typeof window.showFinal === 'function') {
            window.showFinal();
            mediator.publish('modals:final');
        }
    });
}

// {
//     mediator.subscribe('modals:scrollstart', id => {
//         console.log('start' + id);
//         mediator.subscribe('steps:newstep', () => {
//             console.log('newstep');
//             mediator.publish('modals:scrollend', id);
//         });
//     });
// }

module.exports = mediator;


// WEBPACK FOOTER //
// ./js/mediator.js